import React, { Component } from 'react'
import ReactTable from 'react-table'
import {
  Button,
  Form,
  Modal,
  Popconfirm,
  Input,
  InputNumber,
  Checkbox,
  Row,
  Col,
  Table,
  DatePicker,
  AutoComplete,
  Icon,
  Radio,
  message,
  Tooltip
} from 'antd'

import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withRouter } from 'react-router-dom'
import moment from 'moment'
import styled from 'styled-components'
import { actions as transmittalActions } from '../../redux/modules/leadFunctions/leadTransmittalActions'
import { actions as organizationsActions } from '../../redux/modules/organizationsActions'
import OrganizationQuickAdd from '../../components/organization//OrganizationQuickAdd'
import Loader from '../../util/Loader'
import { convertToOption, filterCaseInsensitive } from '../../util'
import _ from 'lodash'
import Attachments from '../../components/attachments/Attachments'
import config from '../../config'

import * as authSelectors from '../../selectors/auth'

const { API_BASE } = config

const AddItemArea = styled.div`
  padding-top: 10px;
  margin-bottom: 10px;
  padding-right: 10px;
`

const FormItem = Form.Item
const { TextArea } = Input
const { Column } = Table
const RadioButton = Radio.Button
const RadioGroup = Radio.Group
const propTypes = {}

const EditableCell = ({ editable, value, onChange }) => (
  <div>
    {editable ? (
      <Input style={{ margin: '-5px 0' }} value={value} onChange={e => onChange(e.target.value)} />
    ) : (
      value
    )}
  </div>
)
class LeadTransmittals extends Component {
  constructor(props) {
    super(props)
    this.state = {
      modalIsShowing: false,
      currentId: 0,
      contentData: null,
      transmittalItems: [],
      transmittalSendings: [],
      transmittalTransmitteds: [],
      addDateInput: null,
      addCopiesInput: 0,
      addNumberInput: 0,
      addDescriptionInput: ''
    }

    this.props.leadTransmittalsRefresh({
      leadId: this.props.leadId
    })
    this.props.getAllOrganizations()
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.leadTransmittalActions.leadTransmittalData !==
      prevProps.leadTransmittalActions.leadTransmittalData
    ) {
      this.setState({
        transmittalItems: this.props.leadTransmittalActions.leadTransmittalData.payload
          .transmittal_items,
        transmittalSendings: this.props.leadTransmittalActions.leadTransmittalData.payload
          .sending_items,
        transmittalTransmitteds: this.props.leadTransmittalActions.leadTransmittalData.payload
          .transmitted_items
      })
    }
  }

  handleRowClick = row => {
    this.setState({
      modalVisible: true,
      currentId: row.id,
      contentData: row,
      transmittedOtherShow: row.transmitted_other ? true : false,
      sendingOtherShow: row.sending_other ? true : false
    })
    this.props.getLeadTransmittalData(row.id)
  }

  handleAddButton = () => {
    this.setState({
      modalVisible: true,
      currentId: 0,
      contentData: null,
      transmittalItems: [],
      transmittalSendings: [],
      transmittalTransmitteds: [],
      addDateInput: null,
      addCopiesInput: 0,
      addNumberInput: 0,
      addDescriptionInput: ''
    })
  }

  handleCancel = () => {
    this.props.form.resetFields()
    this.setState({ data: [], currentId: 0, modalVisible: false })
  }

  getSelectedCompany = value => {
    const companies =
      this.props.organizationsActions &&
      this.props.organizationsActions.payload &&
      this.props.organizationsActions.payload.data
    const selectedCompany = companies.find(job => job.name === value)
    return selectedCompany ? +selectedCompany.id : +value
  }

  handleCreate = () => {
    const form = this.props.form
    form.validateFields((err, values) => {
      if (err) {
        return
      }

      // remove other text or not
      values.sending_other_text = this.state.sendingOtherShow ? values.sending_other_text : null
      values.transmitted_other_text = this.state.transmittedOtherShow
        ? values.transmitted_other_text
        : null

      values.organization_id = this.getSelectedCompany(values.organization_id)

      if (this.state.currentId === 0) {
        this.props.createLeadTransmittal({
          leadId: this.props.leadId,
          content: values,
          sending: this.state.transmittalSendings,
          transmittalItems: this.state.transmittalItems,
          transmitted: this.state.transmittalTransmitteds,
          userId: this.props.user.userId
        })
      } else {
        this.props.updateLeadTransmittal({
          leadId: this.props.leadId,
          transmittalId: this.state.currentId,
          content: values,
          sending: this.state.transmittalSendings,
          transmittalItems: this.state.transmittalItems,
          transmitted: this.state.transmittalTransmitteds,
          userId: this.props.user.userId
        })
      }

      form.resetFields()
      message.success('Changes saved.')
      this.setState({
        contentData: null,
        currentId: 0,
        modalVisible: false,
        transmittalItems: [],
        transmittalSendings: [],
        transmittalTransmitteds: [],
        addDateInput: null,
        addCopiesInput: 0,
        addNumberInput: 0,
        addDescriptionInput: ''
      })
    })
  }

  confirmDelete = event => {
    const form = this.props.form

    this.props.deleteLeadTransmittal({
      leadId: this.props.leadId,
      transmittalId: this.state.currentId
    })

    form.resetFields()
    message.success('Record deleted.')
    this.setState({
      contentData: null,
      currentId: 0,
      modalVisible: false
    })
  }

  onSendingCheckBoxGroupChange = checkedValues => {
    this.setState({
      transmittalSendings: checkedValues,
      sendingOtherShow: checkedValues.includes('sending_other') ? true : false
    })
  }

  onTransmittedCheckBoxGroupChange = checkedValues => {
    this.setState({
      transmittalTransmitteds: checkedValues,
      transmittedOtherShow: checkedValues.includes('transmitted_other') ? true : false
    })
  }

  renderColumns(text, record, column) {
    return (
      <EditableCell
        editable={record.isEditingRow}
        value={text}
        onChange={value => this.handleItemsInputChange(value, record.id, column)}
      />
    )
  }

  handleItemsInputChange = (value, key, column) => {
    const groupedItems = this.state.transmittalItems.map(row => {
      if (row.id === key) row[column] = value
      return row
    })
    this.setState({
      transmittalItems: groupedItems
    })
  }

  handleAddInputChange = (value, input) => {
    this.setState({ [input]: value })
  }

  handleAddItemClick = () => {
    const items = this.state.transmittalItems

    items.push({
      transmittal_date: moment.utc(this.state.addDateInput).format('YYYY-MM-DD'),
      copies: this.state.addCopiesInput,
      number: this.state.addNumberInput,
      description: this.state.addDescriptionInput,
      id: items.length
    })
    this.setState({
      addDateInput: null,
      addCopiesInput: 0,
      addNumberInput: 0,
      addDescriptionInput: '',
      transmittalItems: items
    })
  }

  editRow = rowId => {
    const groupedItems = this.state.transmittalItems.map(row => {
      if (row.id === rowId) row.isEditingRow = true
      return row
    })
    this.setState({
      transmittalItems: groupedItems
    })
  }

  saveRow = rowId => {
    const groupedItems = this.state.transmittalItems.map(row => {
      if (row.id === rowId) {
        row.isEditingRow = false
      }
      return row
    })
    this.setState({
      transmittalItems: groupedItems
    })
  }

  deleteRow = rowId => {
    const groupedItems = this.state.transmittalItems.filter(item => item.id !== rowId)

    this.setState({
      transmittalItems: groupedItems
    })
  }

  /* Organization Quick Add */
  handleQuickAddOrganization = organization => {
    this.props.createNewOrganization({
      organization: organization,
      userId: this.props.user.userId
    })
    setTimeout(() => {
      this.props.getAllOrganizations()
    }, 1000)
  }

  handleBlurOrganization = organization => {
    if (organization !== '')
      this.setState({
        quickAddModalVisibility:
          _.findIndex(this.props.organizationsActions.payload.data, { id: +organization }) < 0 &&
          _.findIndex(this.props.organizationsActions.payload.data, { name: organization }) < 0
            ? true
            : false
      })
  }

  handleCancelQuickAdd = () => {
    this.setState({
      quickAddModalVisibility: !this.state.quickAddModalVisibility
    })
  }
  /* End Organization Quick Add */

  /* attachments */
  uploadAttachment = param => {
    this.props.uploadAttachment({
      formData: param.formData,
      transmittalId: this.state.currentId
    })
  }

  updateAttachmentDescription = param => {
    this.props.updateAttachmentDescription(param)
  }

  deleteAttachment = param => {
    this.props.deleteAttachment(param)
  }

  render() {
    const { contentData } = this.state

    const { getFieldDecorator } = this.props.form
    if (!this.props.leadTransmittalActions.leadTransmittals) {
      return <Loader />
    }
    return (
      <div>
        <OrganizationQuickAdd
          modalVisible={this.state.quickAddModalVisibility}
          handleCancel={this.handleCancelQuickAdd}
          handleQuickAddOrganization={this.handleQuickAddOrganization}
        />
        <Modal
          visible={this.state.modalVisible}
          title="Transmittals"
          okText={contentData ? 'Save Changes' : 'Create'}
          onCancel={this.handleCancel}
          onOk={this.handleCreate}
          width={800}
          maskClosable={false}
        >
          {contentData && (
            <div className="row">
              <div className="col-md-8">
                <h2>RFI #{contentData.id}</h2>
              </div>
              <div className="col-md-4 text-right">
                <div className="row">
                  <div className="col-12">
                    <a
                      href={`${API_BASE}/api/lead/transmittals/${contentData.id}/print`}
                      target="_blank"
                    >
                      <Button icon="printer">Print Transmittal</Button>
                    </a>
                  </div>
                </div>

                <div className="row">
                  <div className="col-12">
                    <FormItem label="Status">
                      {getFieldDecorator('status', {
                        initialValue: contentData ? contentData.status : ''
                      })(
                        <RadioGroup>
                          <RadioButton value="Created">Created</RadioButton>
                          <RadioButton value="Sent">Sent</RadioButton>
                        </RadioGroup>
                      )}
                    </FormItem>
                  </div>
                </div>
              </div>
            </div>
          )}
          <div className="row">
            <div className="col-md-6">
              <FormItem label="Company/Vendor Name">
                {getFieldDecorator('organization_id', {
                  rules: [
                    {
                      required: true,
                      message: 'Company cannot be blank.'
                    }
                  ],
                  initialValue: contentData ? contentData.organization_name : ''
                })(
                  <AutoComplete
                    dataSource={
                      this.props.organizationsActions &&
                      this.props.organizationsActions.payload &&
                      convertToOption(this.props.organizationsActions.payload.data)
                    }
                    filterOption={(inputValue, option) =>
                      option.props.children.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
                    }
                    style={{ width: 320 }}
                    placeholder="Search for a company/vendor"
                    onBlur={this.handleBlurOrganization}
                  >
                    <Input suffix={<Icon type="search" className="certain-category-icon" />} />
                  </AutoComplete>
                )}
              </FormItem>
            </div>
            <div className="col-md-6">
              <FormItem label="Attention">
                {getFieldDecorator('attention', {
                  initialValue: contentData ? contentData.attention : ''
                })(<Input placeholder="Attention to..." />)}
              </FormItem>
            </div>
          </div>
          <Form layout="vertical">
            <FormItem label="Description">
              {getFieldDecorator('description', {
                rules: [
                  {
                    required: true,
                    message: 'Description cannot be blank.'
                  }
                ],
                initialValue: contentData ? contentData.description : ''
              })(<TextArea placeholder="Describe the transmittal..." rows={4} />)}
            </FormItem>
            <h5>We are sending to you:</h5>
            <Checkbox.Group
              style={{ width: '100%' }}
              onChange={this.onSendingCheckBoxGroupChange}
              value={this.state.transmittalSendings}
            >
              <Row>
                <Col span={8}>
                  <Checkbox value="sending_shop_drawings">Shop Drawings</Checkbox>
                </Col>
                <Col span={8}>
                  <Checkbox value="sending_letter">Letter</Checkbox>
                </Col>
                <Col span={8}>
                  <Checkbox value="sending_specifications">Specifications</Checkbox>
                </Col>
                <Col span={8}>
                  <Checkbox value="sending_rfi">RFI</Checkbox>
                </Col>
                <Col span={8}>
                  <Checkbox value="sending_sample">Sample</Checkbox>
                </Col>
                <Col span={8}>
                  <Checkbox value="sending_final_drawings">Final Drawings</Checkbox>
                </Col>
                <Col span={8}>
                  <Checkbox value="sending_proposal">Proposal</Checkbox>
                </Col>
                <Col span={8}>
                  <Checkbox value="sending_contract">Contract</Checkbox>
                </Col>
                <Col span={8}>
                  <Checkbox value="sending_brochure">Brochure</Checkbox>
                </Col>
                <Col span={8}>
                  <Checkbox value="sending_other">Other</Checkbox>
                </Col>
              </Row>
            </Checkbox.Group>
            {this.state.sendingOtherShow && (
              <div className="row">
                <div className="col-md-4">
                  <FormItem label="">
                    {getFieldDecorator('sending_other_text', {
                      initialValue: contentData ? contentData.sending_other_text : ''
                    })(<Input placeholder="Other..." />)}
                  </FormItem>
                </div>
              </div>
            )}
            {this.state.transmittalSendings.length > 0 && (
              <div>
                <Table
                  dataSource={this.state.transmittalItems}
                  size="small"
                  bordered
                  pagination={false}
                  rowKey="id"
                >
                  <Column
                    title="Date"
                    dataIndex="transmittal_date"
                    key="transmittal_date"
                    width={250}
                    render={(text, record) =>
                      this.renderColumns(
                        moment.utc(text).format('MM-DD-YYYY'),
                        record,
                        'transmittal_date'
                      )
                    }
                  />
                  <Column
                    title="Copies"
                    dataIndex="copies"
                    key="copies"
                    render={(text, record) => this.renderColumns(text, record, 'copies')}
                  />
                  <Column
                    title="Number"
                    dataIndex="number"
                    key="number"
                    render={(text, record) => this.renderColumns(text, record, 'number')}
                  />
                  <Column
                    title="Description"
                    dataIndex="description"
                    key="description"
                    render={(text, record) => this.renderColumns(text, record, 'description')}
                  />
                  <Column
                    title=" "
                    dataIndex="action"
                    key="action"
                    render={(text, record) => {
                      return (
                        <div>
                          {record.isEditingRow && (
                            <Button icon="save" onClick={() => this.saveRow(record.id)} />
                          )}
                          {!record.isEditingRow && (
                            <Button icon="edit" onClick={() => this.editRow(record.id)} />
                          )}
                          <Popconfirm
                            title="Are you sure you want to delete this line?"
                            onConfirm={() => this.deleteRow(record.id)}
                            onCancel={this.cancelDelete}
                            okText="Yes"
                            cancelText="No"
                          >
                            <Button className="marginLeft5" type="danger" icon="delete" />
                          </Popconfirm>
                        </div>
                      )
                    }}
                    width={90}
                  />
                </Table>
                <AddItemArea>
                  <div className="row">
                    <div className="col-md-4">
                      <DatePicker
                        format="MM-DD-YYYY"
                        placeholder="Date"
                        value={this.state.addDateInput}
                        onChange={event => this.handleAddInputChange(event, 'addDateInput')}
                      />
                    </div>
                    <div className="col-md-2">
                      <InputNumber
                        placeholder="Copies"
                        value={this.state.addCopiesInput}
                        onChange={event => this.handleAddInputChange(event, 'addCopiesInput')}
                      />
                    </div>
                    <div className="col-md-2">
                      <InputNumber
                        placeholder="Number"
                        value={this.state.addNumberInput}
                        onChange={event => this.handleAddInputChange(event, 'addNumberInput')}
                      />
                    </div>
                    <div className="col-md-2">
                      <Input
                        placeholder="Description"
                        value={this.state.addDescriptionInput}
                        onChange={event =>
                          this.handleAddInputChange(event.target.value, 'addDescriptionInput')
                        }
                      />
                    </div>
                    <div className="col-md-2 text-right">
                      <Button onClick={() => this.handleAddItemClick()}>Add Item</Button>
                    </div>
                  </div>
                </AddItemArea>
              </div>
            )}
            <h5>These are transmitted:</h5>
            <Checkbox.Group
              style={{ width: '100%' }}
              onChange={this.onTransmittedCheckBoxGroupChange}
              value={this.state.transmittalTransmitteds}
            >
              <Row>
                <Col span={8}>
                  <Checkbox value="transmitted_for_review_and_approval">
                    For review and approval
                  </Checkbox>
                </Col>
                <Col span={8}>
                  <Checkbox value="transmitted_approved_as_submitted">
                    Approved as submitted
                  </Checkbox>
                </Col>
                <Col span={8}>
                  <Checkbox value="transmitted_resubmit">Resubmit x copies for approval</Checkbox>
                </Col>
                <Col span={8}>
                  <Checkbox value="transmitted_for_review_and_revision">
                    For review and revision
                  </Checkbox>
                </Col>
                <Col span={8}>
                  <Checkbox value="transmitted_approved_as_noted">Approved as noted</Checkbox>
                </Col>
                <Col span={8}>
                  <Checkbox value="transmitted_as_requested">As requested</Checkbox>
                </Col>
                <Col span={8}>
                  <Checkbox value="transmitted_other">Other</Checkbox>
                </Col>
              </Row>
            </Checkbox.Group>
            {this.state.transmittedOtherShow && (
              <div className="row">
                <div className="col-md-4">
                  <FormItem label="">
                    {getFieldDecorator('transmitted_other_text', {
                      initialValue: contentData ? contentData.transmitted_other_text : ''
                    })(<Input placeholder="Other..." />)}
                  </FormItem>
                </div>
              </div>
            )}
            {contentData && (
              <div className="row">
                <div className="col-12">
                  <Attachments
                    currentId={this.state.currentId}
                    userId={this.props.user.userId}
                    attachmentList={
                      this.props.leadTransmittalActions.transmittalAttachments &&
                      this.props.leadTransmittalActions.transmittalAttachments.data
                    }
                    loadingAttachments={this.props.leadTransmittalActions.loadingAttachments}
                    uploadingAttachment={this.props.leadTransmittalActions.uploadingAttachment}
                    uploadAttachment={this.uploadAttachment}
                    updateAttachmentDescription={this.updateAttachmentDescription}
                    deleteAttachment={this.deleteAttachment}
                    deletingAttachment={this.props.leadTransmittalActions.deletingAttachment}
                  />
                </div>
              </div>
            )}

            <Popconfirm
              title="Are you sure you want to delete this record?"
              onConfirm={this.confirmDelete}
              onCancel={this.cancelDelete}
              okText="Yes"
              cancelText="No"
            >
              {contentData && <Button type="danger" icon="delete" />}
            </Popconfirm>
          </Form>
        </Modal>
        <div className="jobsBar">
          Transmittals
          <div className="jobsBarAdd">
            <i className="fa fa-plus-square" aria-hidden="true" />
            &nbsp;
            <div onClick={() => this.handleAddButton()} className="addJobLabel">
              ADD Transmittal
            </div>
          </div>
        </div>
        {this.props.leadTransmittalActions.leadTransmittals && (
          <ReactTable
            filterable
            defaultFilterMethod={filterCaseInsensitive}
            getTrProps={(state, rowInfo, column, instance) => ({
              onClick: e => this.handleRowClick(rowInfo.original)
            })}
            data={this.props.leadTransmittalActions.leadTransmittals.data}
            columns={[
              {
                columns: [
                  {
                    Header: 'Number',
                    accessor: 'number',
                    maxWidth: 90
                  },
                  {
                    Header: 'Description',
                    id: 'description',
                    accessor: 'description',
                    Cell: d => (
                      <Tooltip title={d.original.description}>{d.original.description}</Tooltip>
                    )
                  },
                  {
                    Header: 'Status',
                    accessor: 'status',
                    maxWidth: 90
                  },
                  {
                    Header: 'Updated Date',
                    id: 'updated_date',
                    accessor: d => moment.utc(d.updated_date).format('M/D/YYYY h:mm:ssa'),
                    maxWidth: 200
                  },
                  {
                    Header: 'Created Date',
                    id: 'created_date',
                    accessor: d => moment.utc(d.created_date).format('M/D/YYYY h:mm:ssa'),
                    maxWidth: 200
                  }
                ]
              }
            ]}
            defaultPageSize={10}
            className="-striped -highlight"
          />
        )}
      </div>
    )
  }
}

const mapStateToProps = (state, props) => ({
  leadTransmittalActions: state.leadTransmittalActions,
  organizationsActions: state.organizationsActions,
  user: authSelectors.getUser(state, props)
})
const mapDispatchToProps = (dispatch, ownProps) => ({
  ...bindActionCreators(Object.assign({}, transmittalActions, organizationsActions), dispatch)
})

LeadTransmittals.propTypes = propTypes
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Form.create()(LeadTransmittals))
)



// WEBPACK FOOTER //
// ./src/pages/lead/LeadTransmittals.container.js